module.exports = __webpack_public_path__ + "static/media/traffic-stat.3e4c706c.svg";